import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=a7081e14&scoped=true"
import script from "./app-main.vue?vue&type=script&lang=ts"
export * from "./app-main.vue?vue&type=script&lang=ts"
import style0 from "./app-main.vue?vue&type=style&index=0&id=a7081e14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7081e14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7081e14')) {
      api.createRecord('a7081e14', component.options)
    } else {
      api.reload('a7081e14', component.options)
    }
    module.hot.accept("./app-main.vue?vue&type=template&id=a7081e14&scoped=true", function () {
      api.rerender('a7081e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/partials/app-main.vue"
export default component.exports